import React from "react";
import { Button as FluentButton, makeStyles, mergeClasses } from "@fluentui/react-components";

const useStyles = makeStyles({
  root: {
    borderRadius: "6px",
    border: "0.25pt solid #C4E1E0",
    backgroundColor: "#ffffff",
    color: "#001C71",
    fontSize: "11px",
    display: "block",
    "&:hover": {
      border: "0.25pt solid #7FBDBA",
      backgroundColor: "#ffffff",
      color: "#001C71",
    },
    "&:disabled": {
      border: "0.25pt solid #E0E0E0",
      backgroundColor: "#F5F5F5",
      color: "#A0A0A0",
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
});

type ButtonProps = {
  label?: string;
  icon?: React.JSX.Element;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
};

const Button: React.FC<ButtonProps> = ({
  label,
  icon,
  onClick,
  disabled = false,
  className = "",
}) => {
  const styles = useStyles();

  return (
    <FluentButton
      icon={icon}
      onClick={onClick}
      disabled={disabled}
      className={mergeClasses(styles.root, className)}
      size="small"
    >
      {label}
    </FluentButton>
  );
};

export default Button;
